export default __webpack_public_path__ + "static/JayaBrekke-ed2f87470966b5959be69a6484eefba0.jpg";